import {
  TRAVEL_ABOUT_STEP,
  TRAVEL_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/Travel/travelSteps";

import { getTravelPriceQueryParams } from "Components/Features/CheckPrice/checkPriceQueryParamUtils";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";

export function mapTravelToForm(
  existingState: Record<string, any>,
  localStorageData?: Record<string, any>,
): FormStates {
  return mapFromQueryParams(mapFromLocalStorage(localStorageData));
}

function mapFromLocalStorage(
  localStorageData?: Record<string, any>,
): FormStates {
  if (!localStorageData) {
    return {};
  }
  const formStates: FormStates = {};
  Object.entries(localStorageData).forEach(([key, value]) => {
    switch (key) {
      case TRAVEL_ABOUT_STEP.id:
        formStates[TRAVEL_ABOUT_STEP.id] = {
          isInsuranceFor: value.isInsuranceFor,
          injuries: value.injuries,
          injuryYear: value.injuryYear,
        };
        return;
      case TRAVEL_PRICE_STEP.id:
        const { coverage } = value;
        if (coverage) {
          formStates[TRAVEL_PRICE_STEP.id] = {
            coverage,
          };
        }
        return;
      default:
        return;
    }
  });
  return formStates;
}

function mapFromQueryParams(formStates: FormStates): FormStates {
  const fromQueryParams = getTravelPriceQueryParams();

  if (fromQueryParams.familyCoverage !== null) {
    formStates[TRAVEL_ABOUT_STEP.id] = {
      isInsuranceFor: booleanToFormBoolean(!fromQueryParams.familyCoverage),
    };
  }
  if (fromQueryParams.injuries !== null) {
    formStates[TRAVEL_ABOUT_STEP.id] = {
      ...formStates[TRAVEL_ABOUT_STEP.id],
      injuries: fromQueryParams.injuries,
    };
  }
  if (
    fromQueryParams.injuries !== null &&
    fromQueryParams.injuries !== DamageRecentYears.NONE &&
    fromQueryParams.injuryYear !== null
  ) {
    formStates[TRAVEL_ABOUT_STEP.id] = {
      ...formStates[TRAVEL_ABOUT_STEP.id],
      injuries: fromQueryParams.injuries,
      injuryYear: fromQueryParams.injuryYear,
    };
  }

  return formStates;
}
